// @flow
import { createAction } from 'redux-act';

export const fetchSquads = createAction('Fetch Squads');
export const fetchSquadsSuccess = createAction('Fetch Squads Success');
export const fetchSquadsFailed = createAction('Fetch Squads Failed');


// WEBPACK FOOTER //
// ./src/modules/actions/squads.js